/* eslint-disable */

import request from '@/utils/request'

export function getListInvoiceCompanyApi(query) {
  return request({
    url: '/config-service/v1/invoice-company/list',
    method: 'get',
    params: query
  })
}

export function getListInvoiceCompanyExcelTemplateApi(query) {
  return request({
    url: '/config-service/v1/invoice-company/to-excel/template',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getListInvoiceCompanyToExcelApi(query) {
  return request({
    url: '/config-service/v1/invoice-company/to-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

export function getInvoiceCompanyByIdApi(query) {
  return request({
    url: `/config-service/v1/invoice-company/${query.id}`,
    method: 'get',
    params: query
  })
}

export function addInvoiceCompanyApi(data) {
  return request({
    url: '/config-service/v1/invoice-company/insert',
    method: 'post',
    data
  })
}

export function insertListInvoiceCompanyExcelApi(data) {
  return request({
    url: '/config-service/v1/invoice-company/excel-insert',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function updateInvoiceCompanyApi(data) {
  return request({
    url: `/config-service/v1/invoice-company/update/${data.id}`,
    method: 'put',
    data
  })
}

export function deleteInvoiceCompanyApi(data) {
  return request({
    url: '/config-service/v1/invoice-company/delete-ids',
    method: 'delete',
    data
  })
}
